import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  MAINTENANCE_CHECKLIST_PATH,
  MAINTENANCE_SERVICE_ORDER_PATH,
  NEW_MAINTENANCE_CHECKLIST_PATH,
} from '../../../../config/paths';
import {
  getMaintenanceChecklists,
  clearMaintenanceChecklists,
} from '../../../../actions/mechanical-maintenance';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { MAINTENANCE_CHECKLIST_COLUMNS } from '../../../../config/columns';

export const MaintenanceChecklists = ({
  breadcrumbs,
  maintenanceChecklists,
  loading,
  dispatchGetMaintenanceChecklists,
  dispatchClearMaintenanceChecklists,
}) => {
  useLayoutEffect(() => () => dispatchClearMaintenanceChecklists(), []);

  const data = maintenanceChecklists.get('content') || [];
  const pages = maintenanceChecklists.get('totalPages') || null;
  const defaultPageSize =
    maintenanceChecklists.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Recepciones de Mantenimiento"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_MAINTENANCE_CHECKLIST_PATH}
      tableStructure={{
        columns: MAINTENANCE_CHECKLIST_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetMaintenanceChecklists,
        modelPath: MAINTENANCE_CHECKLIST_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetMaintenanceChecklists: getMaintenanceChecklists,
  dispatchClearMaintenanceChecklists: clearMaintenanceChecklists,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Recepciones de Mantenimiento',
      href: MAINTENANCE_SERVICE_ORDER_PATH,
    },
  ],
  maintenanceChecklists: MechanicalMaintenanceUnit.MaintenanceChecklist.getIn([
    'all',
    'content',
  ]),
  loading: MechanicalMaintenanceUnit.MaintenanceChecklist.getIn([
    'all',
    'loading',
  ]),
});

MaintenanceChecklists.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  maintenanceChecklists: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetMaintenanceChecklists: PropTypes.func.isRequired,
  dispatchClearMaintenanceChecklists: PropTypes.func.isRequired,
};

MaintenanceChecklists.defaultProps = {
  maintenanceChecklists: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaintenanceChecklists);
